<template>
	<div v-if="page" class="max-w-full overflow-hidden">
		<slot name="top">
			<div class="relative">
				<nk-carousel aria-label="Durchlaufende Bilder" variant="hero-slim">
					<template v-if="shuffledHeroImages">
						<nk-carousel-slide
							v-for="(heroImage, heroImageIndex) in shuffledHeroImages"
							:key="`heroImage-${heroImageIndex}`"
							:bg-image="heroImage.src"
							:bg-image-alt="heroImage.alt"
							:bg-image-copyright="heroImage.copyright"
							bg-image-copyright-position="left top"
						/>
					</template>
					<template v-else-if="defaultHeroImages">
						<nk-carousel-slide
							v-for="(defaultImage, defaultImageIndex) in defaultHeroImages"
							:key="`defaultImage-${defaultImageIndex}`"
							:bg-image="`/images/${defaultImage}`"
						/>
					</template>
				</nk-carousel>
				<div
					v-if="page.breadcrumbs != null && page.breadcrumbs.length"
					class="absolute left-0 top-0 w-full h-full flex justify-center items-center z-20 px-5 lg:px-7"
				>
					<div class="container">
						<NkTitle size="3xl" class="text-neutral-50 has-color m-0">
							{{
								page.breadcrumbs[page.breadcrumbs.length > 2 ? 1 : 0].title ||
								homeTitle
							}}
						</NkTitle>
						<!--- TODO: Breadcrumb cannot access page. --->
						<nk-breadcrumb
							:breadcrumbs="page.breadcrumbs"
							:home-path="homePath"
							:home-title="homeTitle"
						/>
					</div>
				</div>
			</div>
		</slot>

		<NkWrapper v-if="page.isLoading && !page.isQueryOnlyChanging" spacing="xl">
			<NkLoader color="primary" />
		</NkWrapper>
		<nk-container v-else>
			<nk-wrapper spacing="lg">
				<nk-row data-sticky-container gutter="10">
					<!--- Main Col --->
					<nk-col
						cols="full"
						:lg="
							emptySidebar && $slots.sidebar === undefined ? '12/12' : '8/12'
						"
						:class="
							emptySidebar && $slots.sidebar === undefined
								? 'flex justify-center'
								: ''
						"
					>
						<NkWrapper
							v-if="page.isLoading && page.isQueryOnlyChanging"
							spacing="xl"
						>
							<NkLoader color="primary" />
						</NkWrapper>
						<main
							v-else
							:class="
								emptySidebar && $slots.sidebar === undefined
									? 'w-full max-w-[940px]'
									: ''
							"
						>
							<slot name="content">
								<template
									v-for="(module, indexModuleContent) in page.context.filter(
										module =>
											module.slotName === 'content' ||
											typeof module.slotName === 'undefined',
									)"
									:key="indexModuleContent"
								>
									<component
										v-bind="{
											context: module.context,
											options: module.options,
										}"
										:is="componentName(module.template)"
									/>
								</template>
								<!--- Back Button --->
								<nk-button
									v-if="breadcrumbBackUrl"
									color="secondary"
									prepend-icon="arrow-left"
									:link="breadcrumbBackUrl"
								>
									Zurück zur Übersicht
								</nk-button>
								<!--- Back Button End --->
							</slot>
						</main>
					</nk-col>
					<!--- Main Col End --->
					<!--- Sidebar Col --->
					<nk-col
						v-if="!emptySidebar || $slots.sidebar !== undefined"
						cols="full"
						lg="4/12"
						offset
					>
						<nk-sidebar>
							<slot name="sidebar">
								<template
									v-for="(module, indexModuleSidebar) in page.context.filter(
										module => module.slotName === 'sidebar',
									)"
									:key="indexModuleSidebar"
								>
									<component
										v-bind="{
											context: module.context,
											options: module.options,
										}"
										:is="componentName(module.template)"
									/>
								</template>
							</slot>
						</nk-sidebar>
					</nk-col>
					<!--- Sidebar Col End --->
				</nk-row>
			</nk-wrapper>
		</nk-container>
		<slot name="bottom" />
	</div>
</template>

<script>
import PageLayout from '#nk/mixins/page-layout';
import {computed} from 'vue';
import {useCMS} from '#nk/composables/cms';

export default {
	name: 'NkPageDefault',

	mixins: [PageLayout],

	props: {
		homePath: {
			type: String,
			required: false,
			default: '/',
		},
		homeTitle: {
			type: String,
			required: false,
			default: 'Startseite',
		},
	},

	setup() {
		const page = useCMS();

		const breadcrumbBackUrl = computed(() => {
			// Only show if there are more than 3 breadcrumbs and the second-to-last has a URL
			if (
				page.value &&
				Array.isArray(page.value.breadcrumbs) &&
				page.value.breadcrumbs.length >= 3 &&
				page.value.breadcrumbs[page.value.breadcrumbs.length - 2]?.url &&
				!page.value.breadcrumbs[page.value.breadcrumbs.length - 2].url.includes("wegweiser")
			) {
				return page.value.breadcrumbs[page.value.breadcrumbs.length - 2].url;
			}
			return null;
		});

		return {
			page,
			breadcrumbBackUrl,
		};
	},
};
</script>
